import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const ArrowRightSvg: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.width - 8}
    fill="none"
    {...props}
  >
    <path
      stroke="#9DA2A6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeOpacity={0.6}
      strokeWidth={1.5}
      d="m5.25 11.62 3.804-3.803c.449-.45.449-1.184 0-1.634L5.25 2.38"
    />
  </svg>
);
export default ArrowRightSvg;
